import { Field, FieldLabelText, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Grid, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { CurveFittingAlgorithm } from 'Components/Worksheets/Shared/types';
import React from 'react';

const InterpolatedDiameterResultFields = ['D85', 'D60', 'D50', 'D30', 'D15', 'D10'];

let ResultsCalculatedPropertiesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Calculated Properties">
        <Field input={<TextOutput />} label="Total Dry Mass of Specimen" name="WholePortion.Masses.DryMass" />
        <Field
          input={<RadioGroup />}
          name={'Results.ChartOptions.CurveFittingAlgorithm'}
          options={[
            { label: 'Linear', value: CurveFittingAlgorithm.Linear },
            { label: 'Bézier curve', value: CurveFittingAlgorithm.Bezier },
          ]}
        />
      </ListFieldSection>
      <NamePrefixModifier appendNamePrefix={'Results'}>
        <ListFieldSection wide>
          <Grid
            center={true}
            colWidths={60}
            colHeaders={InterpolatedDiameterResultFields.map((f) => (
              <FieldLabelText name={f} />
            ))}
            data={[InterpolatedDiameterResultFields.map((f) => <Field input={<TextOutput />} name={f} />)]}
          />
        </ListFieldSection>
        <ListFieldSection>
          <Field input={<TextOutput />} name="CoefficientOfUniformity" />
          <Field input={<TextOutput />} name="CoefficientOfCurvature" />
          <Field input={<TextOutput />} name="FinenessModulus" />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

ResultsCalculatedPropertiesSection = withInjectedProps(ResultsCalculatedPropertiesSection);

export { ResultsCalculatedPropertiesSection };
export default ResultsCalculatedPropertiesSection;
